import { pick } from 'ramda';

export default pick([
  'autocomplete',
  'autofocus',
  'disabled',
  'form',
  'multiple',
  'name',
  'required',
  'size',
  'value',
]);
